import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: " What services do you offer in iPhone and iOS app development?",
    answer: `<p>TekRevol Offers the following services in iPhone and iOS app development:</p> 
        <ul>
        <li>iOS Development Consulting</li>
        <li>Custom App Development</li>
        <li>UI and UX Design for iPhone</li>
        <li>iOS Web App Development</li>
        <li>iOS App Testing</li>
        <li>App Support and Maintenance with New Features</li>
    </ul>`,
  },
  {
    question:
      "How do you ensure the quality and security of the apps you develop?",
    answer: `<p>We prioritize quality and security with the help of robust testing protocols, utilizing industry best practices and the state-of-the-art security measures. Steady updates and following secure coding practices guarantee the delivery of high-quality, secure apps, meeting industry standards and surpassing client expectations.</p>`,
  },
  {
    question: "What are the advantages of iOS app development services?",
    answer: `<p>iOS app development services offer several advantages, including:</p>  
        <ul>
        <li>Access to a large user base of Apple device users.</li>
        <li>Enhanced security features and strict app review guidelines.</li>
        <li>Integration with Apple's ecosystem, including features like Apple Pay and Siri</li>
        <li>User-friendly interface and consistent user experience across iOS devices.</li>
        <li>Potential for higher user engagement and monetization opportunities through the App Store.</li>
    </ul>`,
  },
  {
    question: "What is your process for developing an iOS app?",
    answer: `<p>We employ the following process for developing an iOS app</p>  
         <ul>
        <li>Ideation</li>
        <li>Design</li>
        <li>Development</li>
        <li>Quality Assurance</li>
        <li>Maintenance & Support</li>
    </ul>`,
  },
  {
    question: " Can you help with getting an app into the Apple App Store?",
    answer: `<p>Absolutely, we provide complete support to guide your app through the Apple App Store submission procedure. Our skilled team is familiar with Apple's guidelines and requirements. We help in formulating all necessary materials, guaranteeing compliance, and navigating the submission procedure flawlessly.</p>`,
  },
  {
    question:
      " Does TekRevol offer ongoing support and maintenance for iOS apps?",
    answer: `<p>Yes. We provide comprehensive support and maintenance services for iOS apps even after the launch. Our team ensures that your iOS app runs smoothly, performs updates, resolves issues, and addresses any maintenance needs to ensure its optimal performance.</p>`,
  },
  {
    question: "How long does it take to develop an iOS app?",
    answer: ` <p>Developing an iOS app timeline can vary depending on the complexity and features required. It typically takes several weeks to a few months to develop an iOS app, considering factors like design, development, testing, and deployment.</p>`,
  },
  {
    question: "What is the cost of developing an iOS app?",
    answer: `  <p>The cost of developing an iOS app depends on various factors such as app complexity, features, design, and development hours. It's best to discuss your specific requirements with our team to get an accurate cost estimate for your iOS app development project.</p>`,
  },
  {
    question:
      "Does TekRevol offer a free consultation or quote for iPhone/iOS app development?",
    answer: ` <p>Yes, TekRevol offers a free consultation and quote for iPhone/ iOS app development. We believe in understanding your app idea, discussing your requirements, and providing you with a tailored solution and cost estimate to bring your iOS app vision to life.</p>`,
  },
  {
    question:
      "Do you have experience developing apps for specific industries or niches?",
    answer: ` <p>Yes, we've developed iOS apps across a wide spectrum of industries. Our iOS app developers have partnered with clients in healthcare, e-commerce, finance, entertainment, and various other sectors. This experience allows us to comprehend distinct industry needs and customize our iPhone app development services to match.</p>`,
  },
  {
    question:
      "  How does your company handle changes in project scope, timelines, deadlines, and guarantees for the work delivered?",
    answer: `<p>We understand that project requirements can evolve over time. Our team follows an agile development approach that allows flexibility in managing changes in project scope, timelines, and deadlines. We maintain transparent communication and provide regular progress updates to ensure that you are informed throughout the development process.</p>`,
  },
  {
    question:
      "Does TekRevol offer cross-platform app development services for iOS and Android?",
    answer: `<p>Yes, TekRevol offers cross-platform app development services, enabling you to build apps that can run on both iOS and Android platforms. This approach ensures cost-effectiveness, faster development, and wider audience reach by targeting multiple platforms simultaneously.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
